export default __webpack_public_path__ + "static/mold-5f78c8e73ed5f4d8d8dfee9a7e43710f.png";